{
    "common": {
        "mon": "Man",
        "tue": "Tir",
        "wed": "Ons",
        "thu": "Tor",
        "fri": "Fre",
        "sat": "Lør",
        "sun": "Søn",
        "jan": "Jan",
        "feb": "Feb",
        "mar": "Mar",
        "apr": "Apr",        
        "jun": "Jun",
        "jul": "Jul",
        "aug": "Aug",
        "sep": "Sep",
        "oct": "Okt",
        "nov": "Nov",
        "dec": "Des",
        "january": "Januar",
        "february": "Februar",
        "march": "Mars",
        "april": "April",
        "may": "Mai",
        "june": "Juni",
        "july": "Juli",
        "august": "August", 
        "september": "September",
        "october": "Oktober",
        "november": "November",
        "december": "Desember",
        "checkin": "Innsjekking",
        "checkout": "Utsjekking",
        "room": "Rom",
        "rooms": "Rom",
        "adult": "Voksen",
        "adults": "Voksne",
        "edit": "Rediger",
        "editCap": "REDIGER",
        "delete": "Slett",
        "deleteCap": "SLETT",
        "localTime": "Lokal Tid",
        "back": "TILBAKE",
        "home": "HJEM",
        "yes": "JA",
        "no": "NEI",
        "left": "Igjen",
        "hour": "Time",
        "hours": "Timer",
        "night": "natt",
        "nights": "netter",
        "for": "for",
        "why": "Hvorfor",
        "get": "Få",
        "more": "Mer",
        "agree": "ENIG",
        "disagree": "UENIG",
        "basedOn": "basert på",
        "error": "Det oppstod en feil, vennligst prøv igjen senere",
        "error2": "Mislyktes, prøv igjen!",
        "error3": "Det oppstod en feil!!",
        "error4": "Det oppstod en feil!! Vennligst prøv igjen",
        "error5": "Beklager!! Det oppstod en feil. Vennligst prøv igjen senere.",
        "hi": "Hei",
        "to": "til",
        "free": "Gratis",
        "per": "Per",
        "at": "kl",
        "day": "Dag",
        "days": "Dager",
        "time": "Tid",
        "of": "av",
        "photo": "Bilde",
        "photos": "Bilder",
        "done": "Ferdig",
        "fullStay": "Hele Oppholdet",
        "date": "Dato",
        "and": "og",
        "bookingDetail": "Bestillingsdetaljer",
        "Back": "Tilbake",
        "Home": "Hjem"
    },
    "userPopup": {
        "myAccount": "Min Konto",
        "welcome": "Velkommen",
        "user": "Bruker",
        "findMyBookings": "FINN MINE BESTILLINGER",
        "viewProfile": "VIS PROFIL",
        "makeAReservarion": "GJØR EN RESERVASJON",
        "logout": "LOGG UT",
        "loginCap": "LOGG INN",
        "login": "Logg inn",
        "invalidCredentials": "Ugyldige påloggingsopplysninger",
        "invalidEmail": "Ugyldig e-post",
        "passwordIsRequired": "Passord er påkrevd",
        "minChar8": "minimum 8 tegn",
        "tooShort": "For Kort!",
        "tooLong": "For Langt!",
        "required": "Påkrevd",
        "emailInvalid": "Skriv inn en gyldig e-post",
        "passwordInvalid": "Skriv inn et gyldig passord",
        "phNumInvalid": "Telefonnummeret er ikke gyldig",
        "signupCap": "REGISTRER DEG",
        "signup": "Registrer deg",
        "verifyText": "Bekreft at det er deg",
        "verifyText2": "Vi har sendt en bekreftelseskode til din e-post",
        "verificationCode": "Bekreftelseskode",
        "didNotReceiveEmail": "Mottok ikke e-post",
        "clickToResend": "Klikk for å sende på nytt",
        "verifyAndSignIn": "Bekreft og Logg inn",
        "otpSentSuccessfully": "OTP sendt vellykket",
        "somethingWentWrong": "Noe gikk galt, vennligst prøv igjen",
        "otpError": "Vennligst skriv inn et gyldig nummer",
        "otpError2": "Vennligst skriv inn kun tall",
        "otpError3": "Feil OTP, vennligst prøv igjen",
        "otpError4": "OTP utløpt, klikk Send på nytt",
        "otpError5": "Vennligst prøv igjen",
        "forgetPassword": "Glemt Passord",
        "submitError": "Brukeren eksisterer ikke!",
        "userExistError": "Brukeren Eksisterer Allerede",
        "checkYourEmail": "Sjekk e-posten din",
        "passwordResetLinkSent": "Vi har sendt en lenke for tilbakestilling av passord til",
        "noWorriesResetInstructions": "Ingen bekymring, vi sender deg tilbakestillingsinstruksjoner.",
        "enterYourEmail": "Skriv inn e-posten din",
        "resetMyPassword": "TILBAKESTILL PASSORDET MITT",
        "setANewPassword": "Angi et nytt passord",
        "newPassword": "Nytt Passord",
        "confirmPassword": "Bekreft Passord",
        "confirmPasswordError": "Passordene må være like",
        "backToLogin": "Tilbake til Innlogging",
        "dontHaveAccount": "Har du ikke en konto?",
        "alreadyHaveAccount": "Har du allerede en konto?",
        "memberDiscount1": "Du vil få",
        "memberDiscount2": "medlemsrabatt for alltid.",
        "discount1": "Administrer alle dine reservasjoner fra ett sted.",
        "discount2": "Registrer deg for personlige anbefalinger og skreddersydde opplevelser!!",
        "discount3": "Bli med i vårt fellesskap av fornøyde gjester og begynn å planlegge oppholdet ditt.",
        "leftGridText1": "Administrer alle dine reservasjoner fra ett sted",
        "leftGridText2": "Registrer deg for personlige anbefalinger og skreddersydde opplevelser!!",
        "leftGridText3": "Bli med i vårt fellesskap av fornøyde gjester og begynn å planlegge oppholdet ditt",
        "gridDiscountText1": "medlemsrabatt på",
        "gridDiscountText2": "utvalgte eiendommer for alltid",
        "gridDiscountText3": "Logg inn for en skreddersydd opplevelse for alltid",
        "gridDiscountText4": "Få Eksklusive Medlemsfordeler",
        "findBookingError": "E-posten din og bestillings-ID samsvarer ikke",
        "verifyAndConfirmBooking": "Bekreft og godkjenn bestilling",
        "confirmEmailText": "Vi har sendt en bekreftelseskode til din e-postadresse",
        "enterCodeText": "Vennligst skriv inn bekreftelseskoden som ble sendt til deg",
        "didNotRecieveEmail": "Mottok ikke e-post?",
        "changeEmailText": "Klikk her for å endre e-postadressen",
        "verifyAndConfirm": "Bekreft og Godkjenn",
        "verified": "BEKREFTET",
        "bookingExpired": "Bestilling Utløpt",
        "bookingExpiredText": "Vi beklager, bestillings-IDen du bruker har utløpt",
        "backToFindingBooking": "Tilbake til Finn Bestilling",
        "findMyBooking": "Finn Mine Bestillinger",
        "bookingEmail": "Bestillings E-post",
        "reservationId": "Reservasjons-ID",
        "findBooking": "FINN BESTILLING",
        "abandonmentCartDoneText1": "Takk!",
        "abandonmentCartDoneText2": "Handlekurvdetaljene dine er sendt til e-posten. Fortsett bestillingen din når som helst.",
        "Recommended Currencies": "Anbefalte Valutaer",
        "All currencies": "Alle valutaer",
        "thisIsRequiredField": "Dette er et påkrevd felt"
    },
    "widget": {
        "destination": "Destinasjon",
        "enterDestination": "Skriv Inn Destinasjon",
        "guests": "Gjester",
        "guest": "Gjest",
        "nationality": "Nasjonalitet",
        "selectNationality": "Velg nasjonalitet",
        "nationalityIsRequired": "Nasjonalitet er påkrevd",
        "selectedRate": "Spesialpris",
        "search": "Søk",
        "ages": "Aldre",
        "orAbove": "Eller Eldre",
        "child": "Barn",
        "children": "Barn",
        "addAnotherRoom": "Legg Til Et Rom Til",
        "removeRoom": "Fjern Rom",
        "property": "Eiendom",
        "city": "By",
        "country": "Land",
        "bookNow": "Bestill Nå",
        "overnightStay": "Overnatting",
        "dayUse": "Dagsbruk",
        "destinationIsRequired": "Destinasjon er påkrevd",
        "checkInIsRequired": "Innsjekkingsdato er påkrevd",
        "checkOutIsRequired": "Utsjekkingsdato er påkrevd",
        "noLocationFound": "Ingen Plassering Funnet",
        "soldOut": "Utsolgt",
        "highDemand": "Høy Etterspørsel",
        "dates": "Datoer",
        "allRates": "Alle priser er i",
        "K": "K",
        "M": "M",
        "sameDayCheckout": "Utsjekking samme dag"
    },
    "promotion": {
        "headingText": "Viktig Informasjon for",
        "regularRate": "Ingen",
        "seniorCitizen": "Seniorpris",
        "agencyRate": "Byråpris",
        "caaRate": "CAA/AAA Pris",
        "corporateRate": "Bedriftspris",
        "governmentRate": "Regjerings/Militærpris",
        "promotionalSpecialRate": "Kampanje/Spesialpris",
        "regularRateDescription": "Ingen kampanje brukt.",
        "seniorCitizenRateDescription": "Dette er en rabattert hotellpris som er tilgjengelig for eldre voksne, vanligvis 60 år eller eldre.",
        "agencyRateDescription": "Dette er en rabattert hotellpris som kun kan nås gjennom spesifikke reisebyråer for å fremme partnerskap og samarbeid.",
        "caaRateDescription": "Dette er en spesiell hotellpris som tilbys til medlemmer av AAA eller CAA for eksklusive besparelser.",
        "corporateRateDescription": "Dette er en rabattert hotellpris tilbudt til forretningsreisende, vanligvis forhandlet mellom hotellet og bedriften.",
        "governmentRateDescription": "Denne prisplanen tilbyr spesifikke rabatter for regjerings-/militærpersonell for å bestille et hotellrom.",
        "contentSeniorCitizen": "Fødselsdatobevis er obligatorisk ved innsjekking. Manglende fremvisning av relevant ID vil resultere i gjeldende priser.",
        "contentAgencyRate": "Sørg for å ha bestillingsbekreftelse og ID-bevis ved ankomst. Manglende fremvisning av disse vil resultere i standardpriser.",
        "contentPromotionalSpecialRate": "Dette er en rabattert hotellpris som tilbys i en begrenset periode, ofte knyttet til spesifikke arrangementer, sesonger eller markedsføringskampanjer.",
        "contentCaaRate": "Vennligst sørg for at du har CAA-medlemskortet eller relevant identifikasjon ved innsjekking. Manglende fremvisning av relevant ID vil resultere i gjeldende priser.",
        "contentCorporateRate": "Bevis på bedrifts-ID eller annen offisiell dokumentasjon kreves ved innsjekking. Manglende fremvisning av relevant bevis vil resultere i gjeldende priser.",
        "contentGovernmentRate": "Gyldig regjerings- eller militær-ID må fremvises ved innsjekking. Manglende fremvisning av nødvendig identifikasjon vil resultere i standardpriser.",
        "CORP": "CORP",
        "AGEN": "AGEN",
        "PROM": "PROM",
        "apply": "BRUK",
        "Offer Code": "Tilbudskode",
        "Agency Code": "Byråkode",
        "Corporate Code": "Bedriftskode",
        "All-Access Rate": "All-Access Pris",
        "errorCode": "Denne koden er ikke gyldig"
    }
}
